import { useEffect, useState } from 'react';

import { MESSAGE_STATE_ERROR, MESSAGE_STATE_SUCCESS } from 'constants/message-app-state-contants';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Button, Input, InputGroup } from 'components/FormComponents';

import { IntegrationCard } from '../IntegrationCard/IntegrationCard';

export const JobylonIntegration = ({
  config,
  integration,
  setLoading = () => {},
  popUpMessage = () => {},
  connectJobylon = () => {},
  disconnectJobylon = () => {},
}) => {
  const { t } = useTranslation();
  const [enabled, setEnabled] = useState(integration.enabled);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      jobylon_company_id: integration.jobylon_company_id || '',
    },
  });

  useEffect(() => {
    if (enabled || !integration.enabled) return;
    disconnectJobylon();
    popUpMessage(t('components.integrations.jobylon.disabled'), MESSAGE_STATE_SUCCESS);
  }, [enabled]);

  const onSubmit = async data => {
    setLoading(true);
    const { payload } = await connectJobylon(data);
    setLoading(false);

    if (payload?.error) {
      popUpMessage(t('components.integrations.jobylon.enableError'), MESSAGE_STATE_ERROR);
      return;
    }

    popUpMessage(t('components.integrations.jobylon.enabled'), MESSAGE_STATE_SUCCESS);
  };

  return (
    <IntegrationCard {...config} enabled={enabled} onToggle={e => setEnabled(e.target.checked)}>
      {enabled && (
        <form onSubmit={handleSubmit(onSubmit)} className="w-full">
          <InputGroup title={t('components.integrations.jobylon.inputs.jobylonCompanyId')}>
            <Input
              name="jobylon_company_id"
              register={register}
              registerOptions={{ required: true }}
              placeholder={t('components.integrations.jobylon.inputs.jobylonCompanyIdPlaceholder')}
              error={errors?.jobylon_company_id?.type}
              inputProps={{ tabIndex: 1 }}
            />
          </InputGroup>

          <Button submit type="secondary" className="w-full mb-3">
            {t('common.save')}
          </Button>
        </form>
      )}
    </IntegrationCard>
  );
};
